import { Link, useLocation, useOutletContext } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';

import { formatParticipantURL } from '../../../utils/functions/ad-board-utils';
import {
  dateFormatter,
  timeFormatter,
} from '../../../utils/functions/common-utils';
import {
  AdBoardEngagementParticipantsDto,
  AdBoardOutletContextType,
} from '../types';

interface ParticipantNameCellProperties {
  filterByUserId: boolean;
  participantName: string;
  createdAt: string;
  userId?: string;
}

// Do no redirect to the attendee page if it's a hidden moderator
const shouldRedirectToAttendee = (
  participant: AdBoardEngagementParticipantsDto | undefined
) => {
  if (
    (participant?.role === 'moderator' &&
      participant?.roleSubType === 'hidden') ||
    !participant
  ) {
    return false;
  }
  return true;
};

export const ParticipantNameCell = ({
  filterByUserId,
  participantName,
  createdAt,
  userId,
}: ParticipantNameCellProperties) => {
  const location = useLocation();
  const participantLink = formatParticipantURL(location, userId);

  const { participantsData } = useOutletContext<AdBoardOutletContextType>();
  const participant = participantsData.find(
    (participantData) => participantData.userId.toString() === userId
  );

  return (
    <Box
      as="span"
      display="inline-block"
      flexDir={'column'}
      width={'130px'}
      data-testid="participant-name"
    >
      {/* userId being optional, participantLink can be null so don't add a link in this case */}
      {participantLink && shouldRedirectToAttendee(participant) ? (
        <Link
          to={participantLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testId="participant-name-cell-link"
        >
          {!filterByUserId && (
            <Text color="keyops.blue">{participantName}</Text>
          )}
        </Link>
      ) : (
        <>{!filterByUserId && participantName}</>
      )}

      <Text color="keyops.gray500">{dateFormatter(createdAt)}</Text>
      <Text color="keyops.gray500">{timeFormatter(createdAt)}</Text>
    </Box>
  );
};
